

 const Loader =()=>{

    
    return (
    
    <div id="preloader">
        {/* Loader */}
        <div id="status">
        <div className="spinner">
            <div className="dot1" />
            <div className="dot2" />
        </div>
        </div>
    </div>
    );
}

export default Loader;